import { ProgramCategoryFilterRow } from 'components/eventView/filters/ProgramCategoryFilterRow';
import { ProgramDayFilterRow } from 'components/eventView/filters/ProgramDayFilterRow';
import { SearchInput } from 'elements/eventView/atomic/SearchInput';
import { EVPcScrollAnchors } from 'pages/EventViewPage/EventViewPagePC/eVScrollAnchors';
import { useIsWideEmbed } from 'pages/custom/embed/useIsWideEmbed';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EmbedProgramHeader = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { programSearchTerm, setProgramSearchTerm } = ctxEventView;
    const isWide = useIsWideEmbed();

    return (
        <S_EmbedProgramHeader className={props.className} id={EVPcScrollAnchors.Program}>
            {ctxEventView.eventData.programSettings?.searchable && (
                <S_SearchInput
                    value={programSearchTerm}
                    onChange={(value) => {
                        setProgramSearchTerm(value);
                    }}
                    clearButton
                />
            )}
            <S_Filters>
                <S_ProgramDayFilterRow />
                <S_ProgramCategoryFilterRow isWide={isWide} />
            </S_Filters>
        </S_EmbedProgramHeader>
    );
};

const S_EmbedProgramHeader = styled.div`
    position: relative;
    padding-top: 70px;
`;
const S_ProgramDayFilterRow = styled(ProgramDayFilterRow)`
    margin-bottom: 0px;
`;

const S_ProgramCategoryFilterRow = styled(ProgramCategoryFilterRow)`
    background: transparent;
    box-shadow: none;
    margin-bottom: 0px;
`;

const S_Filters = styled.div`
    margin-bottom: 50px;
`;

const S_SearchInput = styled(SearchInput)`
    position: absolute;
    width: 300px;
    right: 0;
    top: -5px;
`;
